module.exports = __webpack_public_path__ + "img/serve3.8bd24996.png";